/** ImageSync web app entry point. */
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/ibm-plex-sans/400-italic.css';
import '@fontsource/ibm-plex-serif/500.css';
import '@fontsource/ibm-plex-serif/600.css';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import './styles.css';
import { onSignedOut } from './api.js';
import { startApp } from './app.js';
import { backToSignin, boot, wireSignin } from './signin.js';

onSignedOut(() => backToSignin('Your session has ended. Sign in again to carry on.'));
wireSignin({ signedIn: startApp });
void boot();
